import { render, staticRenderFns } from "./product-option-choice.vue?vue&type=template&id=2b7e5df0"
import script from "./product-option-choice.vue?vue&type=script&lang=ts"
export * from "./product-option-choice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b7e5df0')) {
      api.createRecord('2b7e5df0', component.options)
    } else {
      api.reload('2b7e5df0', component.options)
    }
    module.hot.accept("./product-option-choice.vue?vue&type=template&id=2b7e5df0", function () {
      api.rerender('2b7e5df0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/product-option-choice.vue"
export default component.exports